module.exports = __webpack_public_path__ + "static/media/tff-logo.854c8e63.png";